import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  baselines: [],
  isLoadingBaselines: false,
  baselineDetails: {},
  isLoadingBaselineDetails: false,
  baselineTypes: [],
  isLoadingBaselineTypes: false,
  moduleTypes: [],
  isLoadingModuleTypes: false,
  isCalculatingValue: false,
  isLoadingTime: false,
  isLoadingSensor: false,
  isLoadingLocation: false,
  isLoadingHeatmap: false,
  calculatedLearnedValue: {},
  isLoading: false,
  error: null,
};

export const addBaseline: any = createAsyncThunk(
  "content/InsertBaseLine",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/BaseLine`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const getCalculatedLearnedValue: any = createAsyncThunk(
  "content/getCalculatedLearnedValue",
  async ({ payload }: any) => {
    const res = await axios.get(`/slpapp/Baseline/CalculatedValue`, {
      params: payload,
    });

    const data = await res.data;
    return data;
  }
);

export const editBaseline: any = createAsyncThunk(
  "content/Update",
  async ({ payload, baselineId }: any) => {
    const res = await axios.put(
      `/slpapp/BaseLine`,
      { ...payload, id: baselineId },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const getBaselines: any = createAsyncThunk(
  "content/BaselineList",
  async ({ PageNumber, pageSize, searchText, SortBy, SortDirection }: any) => {
    const res = await axios.get("/slpapp/Baseline/BaselineList", {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });

    const data = await res.data;
    return data;
  }
);

export const getBaselineTypeList: any = createAsyncThunk(
  "content/BaselineTypeList",
  async () => {
    const res = await axios.get(`/slpapp/Baseline/BaselineTypeList`);

    const data = await res.data;
    return data;
  }
);

export const getBaselineModuleTypeList: any = createAsyncThunk(
  "content/BaselineModuleTypeList",
  async () => {
    const res = await axios.get(`/slpapp/Baseline/BaselineModuleTypeList`);

    const data = await res.data;
    return data;
  }
);

export const getBaselineById: any = createAsyncThunk(
  "content/BaseLineId",
  async ({ baselineId }: any) => {
    const res = await axios.get(`/slpapp/Baseline/BaseLineId`, {
      params: { baselineId },
    });
    const data = await res.data?.data;

    return data;
  }
);

export const deleteBasLine: any = createAsyncThunk(
  "content/deleteBasLine",
  async ({ baselineId }: any) => {
    const res = await axios.delete(`/slpapp/Baseline`, {
      params: { baselineId },
    });

    const data = await res.data.data;
    return data;
  }
);

export const baselineSlice = createSlice({
  name: "baseline",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBaselines.pending, (state) => {
      state.isLoadingBaselines = true;
    });
    builder.addCase(getBaselines.fulfilled, (state, action) => {
      state.isLoadingBaselines = false;
      state.baselines = action.payload;
    });
    builder.addCase(getBaselines.rejected, (state, action) => {
      state.isLoadingBaselines = false;
      state.error = action.error.message;
    });

    builder.addCase(getBaselineById.pending, (state) => {
      state.isLoadingBaselineDetails = true;
    });
    builder.addCase(getBaselineById.fulfilled, (state, action) => {
      state.isLoadingBaselineDetails = false;
      state.baselineDetails = action.payload;
    });
    builder.addCase(getBaselineById.rejected, (state, action) => {
      state.isLoadingBaselineDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(getBaselineTypeList.pending, (state) => {
      state.isLoadingBaselineTypes = true;
    });
    builder.addCase(getBaselineTypeList.fulfilled, (state, action) => {
      state.isLoadingBaselineTypes = false;
      state.baselineTypes = action.payload;
    });
    builder.addCase(getBaselineTypeList.rejected, (state, action) => {
      state.isLoadingBaselineTypes = false;
      state.error = action.error.message;
    });

    builder.addCase(getBaselineModuleTypeList.pending, (state) => {
      state.isLoadingModuleTypes = true;
    });
    builder.addCase(getBaselineModuleTypeList.fulfilled, (state, action) => {
      state.isLoadingModuleTypes = false;
      state.moduleTypes = action.payload;
    });
    builder.addCase(getBaselineModuleTypeList.rejected, (state, action) => {
      state.isLoadingModuleTypes = false;
      state.error = action.error.message;
    });

    builder.addCase(getCalculatedLearnedValue.pending, (state, action) => {
      let opName = action?.meta?.arg?.payload?.operationName;

      if (opName) {
        if (opName == "time") {
          state.isLoadingTime = true;
        } else if (opName == "sensor") {
          state.isLoadingSensor = true;
        } else if (opName == "location") {
          state.isLoadingLocation = true;
        } else if (opName == "heatmap") {
          state.isLoadingHeatmap = true;
        }
      }
      state.isCalculatingValue = true;
    });
    builder.addCase(getCalculatedLearnedValue.fulfilled, (state, action) => {
      state.isCalculatingValue = false;

      state.isLoadingTime = false;
      state.isLoadingSensor = false;
      state.isLoadingLocation = false;
      state.isLoadingHeatmap = false;

      state.calculatedLearnedValue = action.payload;
    });
    builder.addCase(getCalculatedLearnedValue.rejected, (state, action) => {
      state.isCalculatingValue = false;

      state.isLoadingTime = false;
      state.isLoadingSensor = false;
      state.isLoadingLocation = false;
      state.isLoadingHeatmap = false;

      state.error = action.error.message;
    });
  },
});

export default baselineSlice.reducer;
